import SuperAdminRootContainer from "./SuperAdminRootContainer";

export default SuperAdminRootContainer;
